export const WavesEnum = Object.freeze({
	WAVE_TOP: 'wave-top',
	WAVE_BOTTOM: 'wave-bottom',
});
